import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { DeletePopupComponent } from "../delete-popup/delete-popup.component";
import { HttpService } from "src/app/services/http/http.service";
import { MatSnackBar } from "@angular/material/snack-bar";

export let allCategoryType = []
@Component({
  selector: "app-categorycuisine",
  templateUrl: "./categorycuisine.component.html",
  styleUrls: ["./categorycuisine.component.scss"],
})
export class CategorycuisineComponent implements OnInit {
  categoryList: any[] = [];
  dataSource: MatTableDataSource<[]> = new MatTableDataSource(
    this.categoryList
  );
  searchText: any;
  dataSourceCopy: any[] = this.categoryList;
  displayedColumns: string[] = ["SI-NO", "icon", "name", "type", "edit", "action"];
  constructor(
    public dialog: MatDialog,
    private httpsv: HttpService,
    private _snackBar: MatSnackBar
  ) { }
  @ViewChild("paginator", { read: MatPaginator }) paginator: MatPaginator;
  ngOnInit(): void {
    this.getCategoryList();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  allergensSlectedFlag = true;
  dietarySlectedFlag = false;
  lengthCategory: number;
  allergensSelectFunc() {
    this.allergensSlectedFlag = true;
    this.dietarySlectedFlag = false;
    // window.location.reload();
    this.getCategoryList();
  }
  dietarySlectFunc() {
    this.allergensSlectedFlag = false;
    this.dietarySlectedFlag = true;
  }
  filter() {
    if (this.searchText == "") {
      this.dataSource = new MatTableDataSource(this.categoryList);
      this.dataSource.paginator = this.paginator;
    } else {
      let temp = this.dataSourceCopy.filter((ele) => {
        return ele.category_name
          .toLocaleLowerCase()
          .match(this.searchText.toLocaleLowerCase());
      });
      this.dataSource = new MatTableDataSource(temp);
      this.dataSource.paginator = this.paginator;
    }
  }
  openDialog(id) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      data: "category",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "true") {
        const data = { id: id };
        this.httpsv.deleteCategory(data).subscribe(
          (res) => {
            if (res["status"] == "TRUE") {
              this.getCategoryList();
              this._snackBar.open("Category is deleted");
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            } else {
              this._snackBar.open(res["message"]);
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            }
            // console.log(res);
          },
          (err: any) => {
            this._snackBar.open("Oops! Something went wrong");
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
            console.log(err);
          }
        );
      }
    });
  }
  editDialog(id) {
    const dialogRef = this.dialog.open(UpdateCategoriesCuisines, {
      width: "550px",
      data: {
        text: "Categories ",
        imgData: this.dataSourceCopy.filter((ele) => id == ele.category_id)[0][
          "image"
        ],
        value: this.dataSourceCopy.filter((ele) => id == ele.category_id)[0][
          "category_name"
        ],
        type: this.dataSourceCopy.filter((ele) => id == ele.category_id)[0][
          "type"
        ],
        id: id
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == false || result == undefined) {
      } else {
        this.httpsv.upadateCategory(result).subscribe(res => {
          if (res['status'] == 'TRUE') {
            this._snackBar.open('Category Updated')
            setTimeout(() => {
              this._snackBar.dismiss()
            }, 2000);
            this.getCategoryList()
          } else {
            this._snackBar.open(res['message'])
            setTimeout(() => {
              this._snackBar.dismiss()
            }, 2000);
          }
        }, (err: any) => {
          this._snackBar.open('Oops! something went wrong')
          setTimeout(() => {
            this._snackBar.dismiss()
          }, 2000);
        })
      }
    });
  }
  addCategoies() {
    const dialogRef = this.dialog.open(AddCategoriesCuisines, {
      width: "700px",
      data: "Categories ",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == false || result == undefined) {
      } else {
        this.httpsv.createCategory(result).subscribe((res) => {
          if (res['status'] == 'TRUE') {
            this._snackBar.open('Category Created')
            setTimeout(() => {
              this._snackBar.dismiss()
            }, 2000);
            this.getCategoryList()
          } else {
            this._snackBar.open(res['message'])
            setTimeout(() => {
              this._snackBar.dismiss()
            }, 2000);
          }
        }, (err: any) => {
          this._snackBar.open('Oops! something went wrong')
          setTimeout(() => {
            this._snackBar.dismiss()
          }, 2000);
        });

      }
    });
  }
  getCategoryList() {
    this.httpsv.allCategory().subscribe(
      (res) => {
        if (res["status"] == "TRUE") {
          let temp = res['result'].data
          let categoryWithoutType = []
          temp.forEach(element => {
            allCategoryType.push(element.type)
            element.category.forEach(ele => {
              categoryWithoutType.push(ele)
            })
          });
          this.categoryList = categoryWithoutType;
          this.dataSource.data = categoryWithoutType;
          this.dataSource.paginator = this.paginator;
          this.dataSourceCopy = categoryWithoutType;
          this.lengthCategory = this.dataSourceCopy.length;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
}
@Component({
  selector: "app-cuisines",
  templateUrl: "./cuisines.html",
})
export class Cuisines implements OnInit {
  cuisinesList: any[] = [];
  dietaryData: MatTableDataSource<[]> = new MatTableDataSource(
    this.cuisinesList
  );
  displayedColumns: string[] = ["SL-NO", "icon", "name", "edit", "action"];
  @ViewChild("paginator2", { read: MatPaginator }) paginator2: MatPaginator;
  ngOnInit(): void {
    this.getCuisinesList();
  }
  ngAfterViewInit(): void {
    this.dietaryData.paginator = this.paginator2;
  }
  constructor(
    public dialog: MatDialog,
    private httpsv: HttpService,
    private _snackBar: MatSnackBar
  ) { }
  searchText: any;
  dataSourceCopy: any[] = this.cuisinesList;
  lengthCusines: number;
  filter() {
    if (this.searchText == "") {
      this.dietaryData = new MatTableDataSource(this.cuisinesList);
      this.dietaryData.paginator = this.paginator2;
    } else {
      let temp = this.dataSourceCopy.filter((ele) => {
        return ele.cuisine_name
          .toLocaleLowerCase()
          .match(this.searchText.toLocaleLowerCase());
      });
      this.dietaryData = new MatTableDataSource(temp);
      this.dietaryData.paginator = this.paginator2;
    }
  }
  editDialog(id) {
    const dialogRef = this.dialog.open(UpdateCategoriesCuisines, {
      width: "550px",
      data: {
        text: "Cuisine ",
        imgData: this.dataSourceCopy.filter((ele) => id == ele.cuisine_id)[0][
          "image"
        ],
        value: this.dataSourceCopy.filter((ele) => id == ele.cuisine_id)[0][
          "cuisine_name"
        ],
        id: id
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == false || result == undefined) {
      } else {
        this.httpsv.updateCuisine(result).subscribe(res => {
          if (res['status'] == 'TRUE') {
            this._snackBar.open('Cuisine Updated')
            setTimeout(() => {
              this._snackBar.dismiss()
            }, 2000);
            this.getCuisinesList()
          } else {
            this._snackBar.open(res['message'])
            setTimeout(() => {
              this._snackBar.dismiss()
            }, 2000);
          }
        }, (err: any) => {
          this._snackBar.open('Oops! something went wrong')
          setTimeout(() => {
            this._snackBar.dismiss()
          }, 2000);
        })
      }
    });
  }
  openDialog(id) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      data: "cuisines",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "true") {
        const data = { id: id };
        this.httpsv.deleteCuisine(data).subscribe(
          (res) => {
            if (res["status"] == "TRUE") {
              this.getCuisinesList();
              this._snackBar.open("Cuisine Deleted");
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            } else {
              this._snackBar.open(res["status"]);
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            }
          },
          (err: any) => {
            this._snackBar.open("Oops! something went wrong");
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
          }
        );
      }
    });
  }
  addCuisines() {
    const dialogRef = this.dialog.open(AddCategoriesCuisines, {
      width: "700px",
      data: "Cuisine ",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == false || result == undefined || result.get("name") == "") {
      } else {
        this.httpsv.createCuisine(result).subscribe(res => {
          if (res["status"] == "TRUE") {
            this.getCuisinesList();
            this._snackBar.open("Cuisine Created");
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
          } else {
            this._snackBar.open(res["status"]);
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
          }
        }, (err: any) => {
          this._snackBar.open("Oops! something went wrong");
          setTimeout(() => {
            this._snackBar.dismiss();
          }, 2000);
        })
      }
    });
  }
  getCuisinesList() {
    this.httpsv.allCuisine().subscribe((res) => {
      if (res["status"] == "TRUE") {
        this.cuisinesList = res["result"].data;
        this.dietaryData.data = res["result"].data;
        this.dietaryData.paginator = this.paginator2;
        this.dataSourceCopy = res["result"].data;
        this.lengthCusines = this.dataSourceCopy.length;
      }
    });
  }
}

@Component({
  selector: "add-categories-cuisine",
  templateUrl: "./add-categories-cuisines-dialog.html",
})
export class AddCategoriesCuisines {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddCategoriesCuisines>,
    private _snackBar: MatSnackBar
  ) { }
  noAdd = [1];
  text = this.data;
  temp = "";
  src: any = "../../../assets/images/Ellipse 11.png";
  sendData: any = new FormData();
  allTypes = allCategoryType
  flag = this.text == 'Categories ' ? true : false;
  type: string = 'N/A';
  onImageChange(event: any) {
    this.sendData.append("file", event.target.files[0]);
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    // console.log(reader);
    reader.onload = (e: any) => {
      this.src = e.target.result;
    };
  }
  addInput() {
    this.noAdd.push(1);
  }
  dataFunc() {
    this.sendData.append("name", this.temp);
    if(this.flag){
      if(this.type == 'N/A'){
        this._snackBar.open('Please select the category type')
        return
      }
      else{
        this.sendData.append("type", this.type);
      }
    }
    // this.sendData.append("id", 1);
    // this.sendData.append("dish_id", 1292);
    this.dialogRef.close(this.sendData);
  }
  close() {
    this.dialogRef.close(false);
  }
}
@Component({
  selector: "update-dialog",
  templateUrl: "./update-dialog.html",
})
export class UpdateCategoriesCuisines {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<UpdateCategoriesCuisines>) { }
  text = this.data.text;
  src = this.data.imgData;
  value = this.data.value;
  type = this.data.type;
  allTypes = allCategoryType
  id = this.data.id
  flag = this.text == 'Categories ' ? true : false;

  sendData: any = new FormData();
  onImageChange(event: any) {
    this.sendData.append("file", event.target.files[0]);
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    // console.log(reader);
    reader.onload = (e: any) => {
      this.src = e.target.result;
    };
  }
  closeDilogFunc() {
    this.dialogRef.close(false)
  }
  updateDilogFunc() {
    this.sendData.append('id', this.id)
    this.sendData.append('name', this.value)
    if (this.flag)
      this.sendData.append('type', this.type)
    this.dialogRef.close(this.sendData)
  }
  // dropDwonFuc(type){
  //   if(type == this.type) return true
  //   else return false
  // }
}
